import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ConfigService } from '../commons';
import { GenericResponse } from '../interfaces';

@Injectable({
  providedIn: 'root'
})
export class CommercialPortfolioService {
  commercialPortfolio = new BehaviorSubject<GenericResponse>(null);

  constructor(private http: HttpClient, private config: ConfigService) {}

  getCommercialPortfolio() {
    return this.http.get<GenericResponse>(this.config.getUrl('pymes.getCommercialPortfolio')).pipe(
      tap((res: GenericResponse) => {
        this.commercialPortfolio.next(res);
      })
    );
  }
}
